import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule as PMultiSelectModule } from 'primeng/multiselect';
import { MultiSelectComponent } from './multi-select.component';

@NgModule({
  imports: [
    CommonModule,
    PMultiSelectModule,
    FormsModule,
    MultiSelectComponent,
  ],
  exports: [MultiSelectComponent],
})
export class MultiSelectModule {}
